<script>
  export default {
    props: {
      color: {
        type: String,
        required: false,
        default: "var(--neutral-500)",
      },
      width: {
        default: 20,
        type: Number,
      },
      height: {
        default: 20,
        type: Number,
      },
    },
  };
</script>
<template>
  <svg
    :height="height"
    :width="width"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :stroke="color"
      d="M18.3332 9.99935C18.3332 14.6017 14.6022 18.3327 9.99984 18.3327M18.3332 9.99935C18.3332 5.39698 14.6022
      1.66602 9.99984 1.66602M18.3332 9.99935H1.6665M9.99984 18.3327C5.39746 18.3327 1.6665 14.6017 1.6665
      9.99935M9.99984 18.3327C12.0842 16.0507 13.2688 13.0893 13.3332 9.99935C13.2688 6.90938 12.0842 3.94798
      9.99984 1.66602M9.99984 18.3327C7.91544 16.0507 6.73088 13.0893 6.6665 9.99935C6.73088 6.90938 7.91544
      3.94798 9.99984 1.66602M1.6665 9.99935C1.6665 5.39698 5.39746 1.66602 9.99984 1.66602"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.67"
    />
  </svg>
</template>

<style>
</style>
